
import { FormControl, InputAdornment, OutlinedInput } from "@mui/material";
import { Box, useTheme } from "@mui/system";
import React from "react";
import { useNavigate } from "react-router-dom";
import {SEARCH_URL, COURSES_URL} from '../../config/urls';

const SearchBar = () =>{
    const theme = useTheme();
    const [currentKey,setCurrentKey] = React.useState('');
    const navigate = useNavigate();

    const changeSearchKey =(e) =>{
        setCurrentKey(e.target.value);
    }

    const submitSearch = (e)=>{
        const realKey = currentKey.trim();
        if(realKey.length) {
            const queryParamsURL= new URLSearchParams({
                'q': realKey,
                'p': 1,
            });
            navigate(`${SEARCH_URL}?${queryParamsURL}`);
        }
        else {
            navigate(COURSES_URL);
        }
        e.preventDefault()
    }

    return(
        <Box>
            <form onSubmit={submitSearch}>
                <FormControl  fullWidth variant="outlined">
                    <OutlinedInput
                        onChange={changeSearchKey}
                        value = {currentKey}
                        placeholder='Find what you want to learn...'
                        sx={{
                            background: theme.palette.background.paper,
                            boxShadow: 4,
                        }}
                        startAdornment={
                        <InputAdornment position="start">
                            <Box
                            component={'svg'}
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            width={24}
                            height={24}
                            >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                            />
                            </Box>
                        </InputAdornment>

                        }
                    />
                </FormControl>
            </form>

      </Box>
    )


}

export default SearchBar;